// The ZAFClient is imported within the index.html file.
// See docs for help regarding the ZAFClient: https://developer.zendesk.com/apps/docs/developer-guide/getting_started

let client

if (typeof ZAFClient === 'undefined') { // eslint-disable-line no-undef
  throw new Error("ZAFClient cannot run outside Zendesk")
} else {
  client = ZAFClient.init() // eslint-disable-line no-undef
  // Skip the fixed sidebar resize when this iframe is loaded as a modal
  // (instances.create({ location: 'modal' })); the modal manages its own size.
  const view = new URLSearchParams(window.location.search).get("view");
  const isModalView = view === "recording_player" || view === "file_viewer";
  if (!isModalView) {
    client.invoke("resize", { height: "240px" });
  }
}

export default client